import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { storeToRefs } from 'pinia';
import { useHeaders } from '../../state';
import LoginPanel from '../common/login/IndexPage.vue';
import { useUserStore } from '../../store';


import { computed } from 'vue';
// 默认头像尺寸

export default {
  __name: 'LogoutCom',
  emits: ['getUserInfo'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    __expose();
    _useCssVars(_ctx => ({
      "2658c70f": _unref(avatarWidth)
    }));
    const avatarWidth = computed(() => `${useHeaders.avatarSize}px`);
    const store = useUserStore();
    const {
      showLoginPanel
    } = storeToRefs(store);
    const redirectUrl = computed(() => window.location.href);
    const loginHandler = () => {
      store.changeShowLoginPanel(true);
    };
    const closeHandler = () => {
      store.changeShowLoginPanel(false);
    };
    const emits = __emit;
    const loginSuccessHandler = () => {
      closeHandler();
      emits('getUserInfo');
    };
    const __returned__ = {
      avatarWidth,
      store,
      showLoginPanel,
      redirectUrl,
      loginHandler,
      closeHandler,
      emits,
      loginSuccessHandler,
      get storeToRefs() {
        return storeToRefs;
      },
      get useHeaders() {
        return useHeaders;
      },
      LoginPanel,
      get useUserStore() {
        return useUserStore;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};